<template>
  <div
    class="image-manager"
  >
    <template>
      <v-file-input
        v-if="!preview"
        :accept="accept"
        color="grey lighten-1"
        counter
        :label="$t('generic.uploadImages')"
        :placeholder="getPlaceholder"
        prependIcon="mdi-cloud-upload-outline"
        outlined
        :showSize="1000"
        :value="localFiles"
        :data-cy="fileInputDataCy"
        v-bind="$attrs"
        v-on="$listeners"
        @change="handleFile"
      >
        <template v-slot:selection="{ index, text }">
          <v-chip
            color="grey lighten-1"
            dark
            label
            small
          >
            {{ text }}
          </v-chip>
        </template>
      </v-file-input>
    </template>
    <UploadedBackendFiles
      :backendFiles="backendFiles"
      :preview="preview"
      :padding="padding"
      :dataCy="filesDataCy"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import UploadedBackendFiles from './UploadedBackendFiles.vue';

export default {
    components: { UploadedBackendFiles },
    model: {
        prop: 'localFiles',
        event: 'change',
    },
    props: {
        localFiles: {
            type: [Array, String],
            default: () => ([]),
        },
        backendFiles: {
            type: [Array, String],
            default: () => ([]),
        },
        placeholder: {
            type: String,
            default: null,
        },
        preview: {
            type: Boolean,
            default: false,
        },
        accept: {
            type: String,
            default: 'image/*',
        },
        padding: {
            type: Number,
            default: 0,
        },
        fileInputDataCy: {
            type: String,
            default: '',
        },
        filesDataCy: {
            type: String,
            default: '',
        },
    },
    computed: {
        getPlaceholder() {
            return this.placeholder ? this.placeholder : this.$t('generic.selectYourImages');
        },
    },
    methods: {
        handleFile(e) {
            this.$emit('sendData', e);
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
